export default __webpack_public_path__ + "static/media/clock.a18dc8c7.svg";